import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
type Bonus = {
  number: string;
  title: string;
  body: string;
  highlight: string;
};
const BONUSES: Bonus[] = [{
  number: '01',
  title: 'Guía Express de Configuración Perfecta para iPhone',
  body: '¿Tienes un iPhone nuevo o sientes que nunca lo configuraste bien? Esta guía te lleva paso a paso por los ajustes más importantes para dejar tu iPhone listo desde el primer día. Pantalla, notificaciones, privacidad, batería, Face ID, iCloud, actualizaciones y organización inicial. Todo en orden, todo claro.',
  highlight: 'Una victoria rápida que notarás en los primeros 30 minutos.'
}, {
  number: '02',
  title: 'Checklist de Seguridad y Privacidad para Proteger tu iPhone',
  body: '¿Tu iPhone está realmente seguro? Este checklist te muestra punto por punto qué revisar para proteger tu información. Bloqueo de pantalla, Face ID, permisos de apps, ubicación, contraseñas, copias de seguridad y protección ante pérdida o robo. Solo sigue la lista y marca lo que ya tienes activado.',
  highlight: 'Más tranquilidad en menos de una hora.'
}, {
  number: '03',
  title: 'Mini Guía de Trucos Ocultos para Ahorrar Tiempo con tu iPhone',
  body: 'Funciones rápidas y poco conocidas que ya tienes en tu iPhone y que te harán ahorrar tiempo todos los días. Atajos de teclado, gestos, búsqueda ultrarrápida, escaneo de documentos, copiar texto desde fotos, capturas inteligentes y comandos que casi nadie usa.',
  highlight: 'Trucos que puedes probar hoy mismo en menos de 5 minutos.'
}, {
  number: '04',
  title: 'Plantilla de Organización Digital para iPhone',
  body: '¿Tienes el celular lleno de apps desordenadas, fotos acumuladas y notas perdidas? Esta plantilla te da una estructura lista para organizar todo. Apps por categorías, pantallas limpias, fotos ordenadas, notas organizadas y una rutina simple de mantenimiento digital semanal.',
  highlight: 'Menos caos, más orden, más control.'
}, {
  number: '05',
  title: 'Manual Rápido de Cámara iPhone para Fotos y Videos Más Profesionales',
  body: 'Tu iPhone tiene una de las mejores cámaras del mercado. Pero si no sabes usarla bien, las fotos siguen saliendo oscuras, borrosas o sin estilo. Este manual te enseña trucos simples de iluminación, enfoque, exposición, composición y edición básica para que tus fotos y videos se vean mucho mejor desde hoy.',
  highlight: 'Resultados visibles desde la primera foto.'
}];
export function Bonuses() {
  return <Section className="bg-ink-900/60" data-id="element-62" data-mp="2xujqjfezfcib">
      <div className="mb-10" data-id="element-63" data-mp="32t3d9i1egsbq">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-accent-soft" data-id="element-64" data-mp="32s24jk7uwhx6">
          Bonos incluidos
        </p>
        <h2 className="text-3xl font-extrabold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-65" data-mp="37l4qb66e6n2t">
          Pero eso no es todo. Hoy también recibes 5 bonos especiales
          completamente gratis.
        </h2>
      </div>

      <img src="https://cdn.magicpatterns.com/patterns/generated-images/a2e32ca6-9aa0-456c-b565-18c2f6008e3a.jpg" alt="Los cinco bonos digitales incluidos con iPhone Experto" className="mb-10 w-full rounded-3xl border border-white/10 object-cover" data-id="element-66" data-mp="27jzszcs4xf52" />

      <div className="space-y-4" data-id="element-67" data-mp="1xkiouzsj79b7">
        {BONUSES.map(bonus => <article key={bonus.number} className="rounded-3xl border border-white/8 bg-ink-950/70 p-6 sm:p-8" data-id="element-68" data-mp="1tkiblih6545q">
            <div className="flex flex-wrap items-center gap-3" data-id="element-69" data-mp="1olnmjyslyjd6">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-accent/15" data-id="element-70" data-mp="1omyp5vabhl2p">
                <GiftIcon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-71" data-mp="1jsm2lcdjntmq" />
              </span>
              <span className="text-xs font-bold uppercase tracking-[0.18em] text-white/40" data-id="element-72" data-mp="1eszs3ap3orhm">
                Bono #{bonus.number}
              </span>
              <span className="rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-emerald-300" data-id="element-73" data-mp="15tcm0blfexi8">
                Gratis para ti hoy
              </span>
            </div>

            <h3 className="mt-4 text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-74" data-mp="3106mfjhdzqak">
              {bonus.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-75" data-mp="2r8ixbp8aylc9">
              {bonus.body}
            </p>
            <p className="mt-4 text-sm font-semibold text-accent-soft" data-id="element-76" data-mp="2w5sw3vhl09cr">
              {bonus.highlight}
            </p>
          </article>)}
      </div>

      <div className="mt-10" data-id="element-77" data-mp="2m8wjbdknh12e">
        <CTAButton className="items-center" data-id="element-78" data-mp="2m9zc5r1j9dky" />
      </div>
    </Section>;
}